// Blended Farms - Simple Delivery Date Picker
// Standalone version - no backend required

(function() {
  'use strict';

  // ==========================================================================
  // EDIT THIS SECTION TO MANAGE BLACKOUT DATES AND DELIVERY DAYS
  // ==========================================================================

  // Dates when delivery is NOT available (format: 'YYYY-MM-DD')
  // To add a new blackout date, add a new line like:  '2026-12-25',
  // To remove a blackout date, delete its line.
  const BLACKOUT_DATES = [
    '2026-08-21',
    '2026-08-22',
  ];

  // Days of the week when delivery IS available
  // 0 = Sunday, 1 = Monday, 2 = Tuesday, 3 = Wednesday,
  // 4 = Thursday, 5 = Friday, 6 = Saturday
  // Default below allows delivery every day of the week.
  const DELIVERY_DAYS_OF_WEEK = [0, 1, 2, 3, 4, 5, 6];

  // How many days into the future to show in the dropdown
  const DAYS_TO_SHOW = 30;

  // ==========================================================================
  // No need to edit anything below this line
  // ==========================================================================

  window.BlendedFarmsDatePicker = window.BlendedFarmsDatePicker || {};

  let modal = null;
  let originalForm = null;

  function createModal() {
    if (modal) return;

    const modalHTML = `
      <div id="bf-date-modal" style="
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.7);
        z-index: 99999;
        align-items: center;
        justify-content: center;
      ">
        <div style="
          background: white;
          border-radius: 12px;
          padding: 30px;
          max-width: 400px;
          width: 90%;
          position: relative;
          box-shadow: 0 10px 30px rgba(0,0,0,0.3);
        ">
          <button id="bf-close-modal" style="
            position: absolute;
            top: 15px;
            right: 20px;
            background: none;
            border: none;
            font-size: 24px;
            cursor: pointer;
            color: #666;
          ">&times;</button>

          <div style="text-align: center; margin-bottom: 25px;">
            <h2 style="margin: 0; color: #333; font-size: 24px;">Select Delivery Date</h2>
            <p style="margin: 10px 0 0 0; color: #666;">Choose your preferred delivery date</p>
          </div>

          <div style="margin-bottom: 20px;">
            <label style="display: block; margin-bottom: 5px; font-weight: 600; color: #333;">Delivery Date *</label>
            <select id="bf-delivery-date" required style="
              width: 100%;
              padding: 12px;
              border: 2px solid #e1e3e5;
              border-radius: 6px;
              font-size: 14px;
              box-sizing: border-box;
              background: white;
            ">
              <option value="">Select a delivery date...</option>
            </select>
            <div style="font-size: 12px; color: #666; margin-top: 5px;">
              Only available dates are shown
            </div>
          </div>

          <div id="bf-date-error" style="
            display: none;
            background: #fee;
            color: #c33;
            padding: 10px;
            border-radius: 4px;
            margin-bottom: 15px;
            text-align: center;
          "></div>

          <button id="bf-add-to-cart" style="
            width: 100%;
            background: #008060;
            color: white;
            border: none;
            padding: 15px;
            border-radius: 8px;
            font-size: 16px;
            font-weight: 600;
            cursor: pointer;
          ">
            Add to Cart with Delivery Date
          </button>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);
    modal = document.getElementById('bf-date-modal');

    setupEventListeners();
  }

  function isDateAvailable(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateStr = `${year}-${month}-${day}`;

    if (BLACKOUT_DATES.includes(dateStr)) {
      return false;
    }

    const dayOfWeek = date.getDay();
    if (!DELIVERY_DAYS_OF_WEEK.includes(dayOfWeek)) {
      return false;
    }

    return true;
  }

  function setupEventListeners() {
    document.getElementById('bf-close-modal').onclick = closeModal;
    modal.onclick = function(e) {
      if (e.target === modal) closeModal();
    };

    document.getElementById('bf-add-to-cart').onclick = addToCartWithDate;

    populateAvailableDates();
  }

  function populateAvailableDates() {
    const dateSelect = document.getElementById('bf-delivery-date');
    dateSelect.innerHTML = '<option value="">Select a delivery date...</option>';

    const availableDates = [];
    let checkDate = new Date();
    checkDate.setDate(checkDate.getDate() + 1); // Start from tomorrow

    for (let i = 0; i < DAYS_TO_SHOW; i++) {
      if (isDateAvailable(checkDate)) {
        const year = checkDate.getFullYear();
        const month = String(checkDate.getMonth() + 1).padStart(2, '0');
        const day = String(checkDate.getDate()).padStart(2, '0');
        const dateStr = `${year}-${month}-${day}`;

        const formattedDate = checkDate.toLocaleDateString('en-US', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });

        availableDates.push({
          value: dateStr,
          text: formattedDate
        });
      }
      checkDate.setDate(checkDate.getDate() + 1);
    }

    availableDates.forEach(date => {
      const option = document.createElement('option');
      option.value = date.value;
      option.textContent = date.text;
      dateSelect.appendChild(option);
    });

    if (availableDates.length > 0) {
      dateSelect.value = availableDates[0].value;
    } else {
      dateSelect.innerHTML = '<option value="">No delivery dates available</option>';
    }
  }

  function showModal(form) {
    originalForm = form;
    if (!modal) createModal();
    modal.style.display = 'flex';
  }

  function closeModal() {
    if (modal) {
      modal.style.display = 'none';
      document.getElementById('bf-date-error').style.display = 'none';
    }
  }

  function validateDate() {
    const dateSelect = document.getElementById('bf-delivery-date');
    const errorDiv = document.getElementById('bf-date-error');

    if (!dateSelect.value) {
      errorDiv.textContent = 'Please select a delivery date';
      errorDiv.style.display = 'block';
      return false;
    }

    errorDiv.style.display = 'none';
    return true;
  }

  async function addToCartWithDate() {
    if (!validateDate() || !originalForm) return;

    try {
      const formData = new FormData(originalForm);

      const deliveryDate = document.getElementById('bf-delivery-date').value;

      const dateParts = deliveryDate.split('-');
      const selectedDate = new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]));
      const formattedDate = selectedDate.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });

      formData.append('properties[Delivery Date]', formattedDate);
      formData.append('properties[Delivery Required]', 'Yes');

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      closeModal();
      window.location.href = '/cart';

    } catch (error) {
      console.error('Error:', error);
      const errorDiv = document.getElementById('bf-date-error');
      errorDiv.textContent = 'Failed to add to cart. Please try again.';
      errorDiv.style.display = 'block';
    }
  }

  function interceptCartForms() {
    const forms = document.querySelectorAll('form[action*="/cart/add"], form[action="/cart/add.js"]');

    forms.forEach(form => {
      const submitHandler = function(e) {
        e.preventDefault();
        e.stopPropagation();
        showModal(form);
      };

      form.addEventListener('submit', submitHandler);

      const submitButtons = form.querySelectorAll('button[type="submit"], input[type="submit"], button:not([type])');
      submitButtons.forEach(btn => {
        btn.addEventListener('click', submitHandler);
      });
    });
  }

  function init() {
    createModal();
    interceptCartForms();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  setTimeout(init, 1000);

})();